import * as React from 'react';
import ReactPlayer from 'react-player';

import { Link } from '../Link/Link';
import { track } from '../../utils/analytics';

import * as cs from './VideoEmbed.module.css';

interface Props {
  url: string;
}

// Supports file paths, YouTube, Facebook, Twitch, SoundCloud, Streamable, Vimeo, Wistia, Mixcloud, DailyMotion and Kaltura.
export const VideoEmbed = ({ url }: Props) => {
  const fallback = (
    <Link to={url} target="_blank">
      {url}
    </Link>
  );

  const handlePlay = () => {
    track('event-media-play-video', url);
  };

  return (
    <div className={cs.video}>
      <ReactPlayer
        url={url}
        controls
        playsinline
        pip
        width="100%"
        height="100%"
        className={cs.player}
        fallback={fallback}
        config={{
          file: {
            forceVideo: true,
          },
        }}
        onStart={handlePlay}
      />
    </div>
  );
};
